import './styles.css';

import React, { useState } from 'react';
import { IEpisode } from 'interface/cast';
import { getCdnUrl, appPostMessage } from 'utils';
import defaultImage from 'assets/img/default-course-img.png';

interface IProps {
  episode: IEpisode;
}

const EpisodeItem = ({ episode }: IProps) => {
  const [img, setImg] = useState(getCdnUrl(episode?.coverUrl, defaultImage));

  const handleImgError = () => {
    setImg(defaultImage);
  };

  const handleClick = () => {
    appPostMessage('navigate-to-episode', { episode });
  };

  return (
    <span role='button' className='nc-episode' onClick={handleClick}>
      <img src={img} alt={`Episódio ${episode?.title}`} onError={handleImgError} />
      <label className='nc-episode-title'>{episode?.title}</label>
    </span>
  );
};

export default EpisodeItem;
